import styled from 'styled-components'

const Wrapper = styled.div`
  text-align: center;
`

export const DurationTypesWrapper = styled.div`
  display: flex;
  gap: 5px;
  justify-content: center;

  text-align: center;
  button {
    width: 80px;
  }
`

const MARGIN = 5
const BUTTON_WIDTH = 60

export const DurationsWrapper = styled(Wrapper)`
  width: 100%;
  margin: 0 auto;
  text-align: left;
  display: grid;
  grid-template-columns: repeat(7, 60px);
  justify-content: center;
  gap: ${MARGIN}px;

  &.weeks {
    grid-template-columns: repeat(4, 60px);
  }

  &.days {
    grid-template-columns: repeat(5, 60px);

    @media (min-width: ${BUTTON_WIDTH * 7 + MARGIN * 8}px) {
      grid-template-columns: repeat(7, 60px);
    }
  }

  &.hours {
    grid-template-columns: repeat(4, 60px);

    @media (min-width: ${BUTTON_WIDTH * 6 + MARGIN * 7}px) {
      grid-template-columns: repeat(6, 60px);
    }
  }
`
